import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import axios from "axios";
import Header from "../Header";
import Footer from "../Footer";
import FlashMessage from "../FlashMessage";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import $ from "jquery";
import "datatables.net-bs5";
import { Link } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import printNewQuoteInvoice from "./printNewQuoteInvoice";
import config from "../common/Config";
import Swal from "sweetalert2";
import { setTableWidths, getTableWidths, setTableColumnVisibility, getTableColumnVisibility } from "../../data/postAPi";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import { format } from "date-fns";
import "../css/custom-filter.css";
import ManageColumns from "../tableComponents/manageColumns/ManageColumns";
import FallbackManageColumns from "../tableComponents/manageColumns/FallbackManageColumns";
import StandaloneManageColumnsModal from "../tableComponents/manageColumns/StandaloneManageColumnsModal";

const NewRSales = () => {
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [newSales, setNewSales] = useState([]);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const changeCustmodalRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [rejectData, setRejectData] = useState([]);
  const [rejectComment, setRejectComment] = useState("");
  const [flashMessage, setFlashMessage] = useState(null);
  const [changeCustData, setchangeCustData] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showHoldModal, setShowHoldModal] = useState(false);
  const orderIdRef = useRef(null);
  const reasonRef = useRef(null);
  const accessToken = localStorage.getItem("accessToken");
  const roleID = localStorage.getItem("roleID");
  const salesOrderRef = useRef(null);
  const [searchValue, setSearchValue] = useState([]);
  const [checkedValues, setCheckedValues] = useState([]);
  const user_id = localStorage.getItem("userId");

  // Amt Due Modal States
  const [showAmtDueModal, setShowAmtDueModal] = useState(false);
  const [amtDueLedgerData, setAmtDueLedgerData] = useState(null);
  const [amtDueCustomer, setAmtDueCustomer] = useState(null);
  const [amtDueCustomerId, setAmtDueCustomerId] = useState(null);

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    $(".dataTableCheckboxNew").prop("checked", isChecked);
  };

  const fetchCustomerNameOptions = async (inputValue) => {
    if (inputValue.length < 3) {
      return;
    }

    const formData = new FormData();
    formData.append("term", inputValue);
    formData.append("limit", "10");

    const apiSalesRapUrl = `${config.API_URL}/suggestions`;
    try {
      const response = await fetch(apiSalesRapUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (Array.isArray(data.results)) {
        const formattedOptions = data.results.map((item) => ({
          label: item.text,
          value: item.id,
        }));
        setCustomerOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching customer options:", error);
    }
  };

  const handleInputChange = (inputValue) => {
    fetchCustomerNameOptions(inputValue);
  };

  const handleChange = (selectedOption) => {
    setCustomerInputValue(selectedOption);
  };

  const handleGenerateQuotePDF = (orderId) => {
    printNewQuoteInvoice(orderId);
  };

  const handleRejCommentChange = (event) => {
    setRejectComment(event.target.value);
  };

  const rejectFormData = async () => {
    const reason = rejectComment;

    if (!reason) {
      Swal.fire({
        title: "Failed!",
        text: "Please enter reason for reject.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    } else {
      const formData = new FormData();
      formData.append("status", "Reject");
      formData.append("reason_note", reason);
      formData.append("new-sales", 'Yes');
      formData.append("id", rejectData.ids);

      const apistatusUrl = `${config.API_URL}/ws-update-status`;
      try {
        const response = await fetch(apistatusUrl, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        if (!response.ok) {
          setFlashMessage({
            message: "something went wrong, try again",
            type: "error",
          });
        }

        const data = await response.json();
        console.log("API Response:", data);
        setFlashMessage({
          message: "Order rejected successfully",
          type: "success",
        });
        setShowRejectModal(false);
        setRejectComment("");
        
        if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
          $('#neworderTable_old').DataTable().ajax.reload();
        } else {
          getSalesOrderList();
        }
      } catch (error) {
        console.error("Error rejecting order:", error);
        setFlashMessage({
          message:
            "Error rejecting order. Please check the console for details",
          type: "error",
        });
      }
    }
  };

  const changeCustFormData = async () => {
    let customerId = customerInputValue ? customerInputValue : "";
    if (customerId.value != null) {
      const formData = new FormData();
      formData.append("id", changeCustData.ids);
      formData.append("customer_id", customerId.value);

      const apistatusUrl = `${config.API_URL}/ws-update_customer_to_order`;
      try {
        const response = await fetch(apistatusUrl, {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        });

        if (!response.ok) {
          setFlashMessage({
            message: "something went wrong, try again",
            type: "error",
          });
        }
        const data = await response.json();
        console.log("API Response:", data);
        setFlashMessage({
          message: "Customer Change successfully",
          type: "success",
        });
        
        if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
          $('#neworderTable_old').DataTable().ajax.reload();
        } else {
          getSalesOrderList();
        }
      } catch (error) {
        console.error("Error rejecting order:", error);
        setFlashMessage({
          message:
            "Error Change Customer. Please check the console for details",
          type: "error",
        });
      }
    } else {
      Swal.fire({
        title: "Failed!",
        text: "Please select customer name.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
    }
  };

  // Handle Amt Due Click - FIXED VERSION
  const handleAmtDueClick = async (row) => {
    console.log("Amt Due clicked for:", row); // Debug log
    
    setAmtDueCustomer(row.customer);
    setAmtDueCustomerId(row.customer_id || row.ids); // Use customer_id if available, fallback to ids
    setAmtDueLedgerData(null); // Reset data
    setShowAmtDueModal(true);
    const formData = new FormData();
  formData.append("customerId", row.customer_id);
  formData.append("platform", "web");
  formData.append("showDueInvoicesOnly", "Y");
  formData.append("authorization", `Bearer ${accessToken}`);
    // Fetch ledger data for the customer
    try {
      const response = await fetch(`${config.API_URL}/ws-get-previous-invoice-list`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (response.ok) {
        const ledgerData = await response.json();
        // If you want to append new data to the existing ledger data:
        setAmtDueLedgerData(prev => (prev ? [...prev, ...(ledgerData.invoice_details || [])] : (ledgerData.invoice_details || [])));
      } else {
        console.error("Failed to fetch ledger data");
        setAmtDueLedgerData([]);
      }
    } catch (error) {
      console.error("Error fetching ledger data:", error);
      setAmtDueLedgerData([]);
    }
  };

  // Set up reject modal click handler
  $(document)
    .off("click", "#neworderTable_old .rejectmdlBtn")
    .on("click", "#neworderTable_old .rejectmdlBtn", function () {
      const salesData = $(this).attr("data-order");
      const salesOrder = JSON.parse(decodeURIComponent(salesData));
      setRejectData([]);
      setTimeout(() => {
        setRejectData(salesOrder);
      }, 0);
      setShowRejectModal(true);
    });

  const [dates, setDates] = useState([null, null]);
  const startDateRef = useRef("");
  const endDateRef = useRef("");
  
  const handleDateRangeChange = (value) => {
    setDates(value);
    const start = value && value[0] ? new Date(value[0]) : null;
    const end = value && value[1] ? new Date(value[1]) : null;
    if (start && end) {
      const s1 = format(start, "yyyy-MM-dd");
      const e1 = format(end, "yyyy-MM-dd");
      setStartDate(s1);
      setEndDate(e1);
      startDateRef.current = s1;
      endDateRef.current = e1;
      
      setTimeout(() => {
        getSalesOrderList();
      }, 100);
    } else {
      setStartDate("");
      setEndDate("");
      startDateRef.current = "";
      endDateRef.current = "";
    }
  };

  const handleCloseMessage = () => {
    setFlashMessage(null);
  };

  const [colWidths, setColWidths] = useState([50, 80, 80, 120, 80, 80, 80, 80, 80, 80, 80]);

  const tableRef = useRef(null);
  const userId = localStorage.getItem("userId");
  const tableName = "newRSalesTable";

  const tableColumns = [
    { header: "Checkbox", visible: true },
    { header: "Order Date", visible: true },
    { header: "Order Id", visible: true },
    { header: "Customers (A/C No)", visible: true },
    { header: "Post Code", visible: true },
    { header: "Route", visible: true },
    { header: "Order Amt", visible: true },
    { header: "Profit(%)", visible: true },
    { header: "C.Bal", visible: true },
    { header: "Amt.Due", visible: true },
    { header: "Order By", visible: true },
    { header: "Status", visible: true },
    { header: "Action", visible: true }
  ];

  const [columnVisibility, setColumnVisibility] = useState(() => {
    const defaultVisibility = {};
    tableColumns.forEach((_, index) => {
      defaultVisibility[index] = true;
    });
    return defaultVisibility;
  });
  const [showFallbackModal, setShowFallbackModal] = useState(false);

  const handleColumnVisibilityChange = async (newVisibility) => {
    console.log('Updating column visibility:', newVisibility);
    setColumnVisibility(newVisibility);

    try {
      await setTableColumnVisibility(userId, tableName, newVisibility);
    } catch (error) {
      console.error('Error saving column visibility:', error);
    }

    if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
      const table = $('#neworderTable_old').DataTable();
      tableColumns.forEach((column, index) => {
        const isVisible = newVisibility[index] !== false;
        table.column(index).visible(isVisible);
      });
      table.draw();
    }
  };

  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;

  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(30, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([50, 80, 80, 120, 80, 80, 80, 80, 80, 80, 80]);
        }
      } catch (e) {
        setColWidths([50, 80, 80, 120, 80, 80, 80, 80, 80, 80, 80]);
      }

      try {
        const visibilityResponse = await getTableColumnVisibility(userId, tableName);
        if (visibilityResponse?.data?.column_visibility) {
          console.log('Loaded column visibility from API:', visibilityResponse.data.column_visibility);
          setColumnVisibility(visibilityResponse.data.column_visibility);
        } else {
          const defaultVisibility = {};
          tableColumns.forEach((_, index) => {
            defaultVisibility[index] = true;
          });
          setColumnVisibility(defaultVisibility);
        }
      } catch (error) {
        console.error('Error loading column visibility from API:', error);
        const defaultVisibility = {};
        tableColumns.forEach((_, index) => {
          defaultVisibility[index] = true;
        });
        setColumnVisibility(defaultVisibility);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
      const table = $('#neworderTable_old').DataTable();
      tableColumns.forEach((column, index) => {
        const isVisible = columnVisibility[index] !== false;
        table.column(index).visible(isVisible);
      });
      table.draw();
    }
  }, [columnVisibility]);

  const getSalesOrderList = () => {
    const $table = $(salesOrderRef.current);
    if (!$table.length) return;

    // If DataTable is already initialized, reload it with new parameters
    if ($table && $table.length && $.fn.DataTable.isDataTable($table)) {
      // Instead of returning, just reload the DataTable via ajax.reload()
      $table.DataTable().ajax.reload();
      return;
    }

    $table.DataTable({
      processing: true,
      serverSide: true,
      pageLength: 50,
      ajax: {
        url: `${config.API_URL}/sales/saleslist_test`,
        type: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        data: function (d) {
          return {
            ...d,
            draw: d.draw,
            start: d.start,
            length: d.length,
            searchValue: $("#searchValue").val(),
            searchByFromdate: startDateRef.current,
            searchByTodate: endDateRef.current,
          };
        },
        dataSrc: function (json) {
          // Only update state if DataTable is being initialized, not on every reload
          if (!$.fn.DataTable.isDataTable($table)) {
            if (json?.data && Array.isArray(json.data)) {
              setNewSales(json.data);
              return json.data;
            }
            return [];
          }
          // For reloads, just return the data
          return json?.data || [];
        },
        error: function (xhr) {
          console.error("DataTable AJAX error:", xhr.responseText);
        },
      },
      language: {
        paginate: {
          first: "First",
          last: "Last",
          next: "Next",
          previous: "Previous",
        },
        search: "Search:",
      },
      columns: [
        {
          data: null,
          visible: columnVisibility[0] !== false,
          render: function (data, type, row) {
            if (row.sale_status !== "Hold") {
              return `
                <label class="checkbox">
                  <input 
                    type="checkbox" 
                    class="dataTableCheckboxNew" 
                    value="${row.ids}"
                  />
                  <span class="default"></span>
                </label>
              `;
            } else {
              return '';
            }
          }
        },
        {
          data: "date",
          visible: columnVisibility[1] !== false,
          render: (data, type, row) => colorRow(row, "date")
        },
        {
          data: "reference_no",
          visible: columnVisibility[2] !== false,
          render: (data, type, row) => {
            const isHoldOrNotAllowed = row.sale_status === "Hold" || roleID === '20';
            const ref = row.reference_no;
            const url = accessToken === 'sdm'
              ? `${config.BASE_URL}/sales/edit_invoice_sdm/${row.ids}`
              : `${config.BASE_URL}/sales/edit_invoice/${row.ids}`;
            return isHoldOrNotAllowed
              ? `<label style="color: #f14240;">${ref}</label>`
              : `<a class="underlined-link" href="${url}">${ref}</a>`;
          }
        },
        {
          data: "customer",
          visible: columnVisibility[3] !== false,
          render: (data, type, row) => colorRow(row, "customer"),
        },
        {
          data: "postal_code",
          visible: columnVisibility[4] !== false,
          render: (data, type, row) => colorRow(row, "postal_code"),
        },
        {
          data: "route_number",
          visible: columnVisibility[5] !== false,
          render: (data, type, row) => colorRow(row, "route_number"),
        },
        {
          data: "grand_total",
          visible: columnVisibility[6] !== false,
          render: (data, type, row) => colorRow(row, "grand_total"),
        },
        {
          data: "profit",
          visible: columnVisibility[7] !== false,
          render: (data, type, row) => colorRow(row, "profit"),
        },
        {
          data: "prev_due",
          visible: columnVisibility[8] !== false,
          render: (data, type, row) => colorRow(row, "prev_due"),
        },
        {
          data: "amtDue",
          visible: columnVisibility[9] !== false,
          className: "text-end", // Add this line for right alignment
          render: (data, type, row) => {
            const encodedRow = encodeURIComponent(JSON.stringify(row));
            return `<a href="#" class="amt-due-link" data-order='${encodedRow}' style="color: #007bff; text-decoration: underline; cursor: pointer;">${row.amtDue}</a>`;
          }
        },
        {
          data: "name",
          visible: columnVisibility[10] !== false,
          render: (data, type, row) => colorRow(row, "name")
        },
        {
          data: "sale_status",
          visible: columnVisibility[11] !== false,
          render: (data, type, row) => colorRow(row, "sale_status"),
        },
        {
          data: null,
          visible: columnVisibility[12] !== false,
          render: function (data, type, row) {
            let html = `<div class="action-popdot"> 
                          <a class="icon" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-three-dots"></i>
                          </a>
                          <ul class="dropdown-menu dropdown-menu-end dropdown-menu-arrow" style="">
                            <li>
                              <a class="deductionbtn rejectmdlBtn" title="Reject Order" data-action="reject" data-order='${encodeURIComponent(JSON.stringify(data))}'>
                                <i class="bi bi-ban"></i> Reject
                              </a>
                            </li>`;

            if (row.sale_status === "New") {
              html += `<li>
                         <a class="deductionbtn" data-action="hold" data-order="${row.ids}" title="Hold Order">
                           <i class="bi bi-pause-fill"></i> Hold
                         </a>
                       </li>
                       <li>
                         <a href="${config.BASE_URL}/new_sales/invoice/${row.ids}" title="Print Invoice">
                           <i class="bi bi-printer"></i> Print Invoice
                         </a>
                       </li>
                       <li>
                         <a href="#" class="printQuotation" data-id="${row.ids}" title="Print Quote">
                           <i class="bi bi-chat-left-quote"></i> Print Quote
                         </a>
                       </li>`;
            } else if (row.sale_status === "Hold") {
              html += `<li>
                         <a class="ConvertToNewOrder" data-action="new" title="New Order" data-order="${row.ids}">
                           <i class="bi bi-cart-plus"></i> New Order
                         </a>
                       </li>
                       <li>
                         <a href="#" class="printQuotation" data-id="${row.ids}" title="Print Quote">
                           <i class="bi bi-chat-left-quote"></i> Print Quote
                         </a>
                       </li>`;
            }

            return html + `</ul></div>`;
          }
        }
      ],
      columnDefs: [
        { targets: [0], orderable: false },
        ...tableColumns.map((column, index) => ({
          targets: index,
          visible: columnVisibility[index] !== false
        }))
      ],
      createdRow: function (row, data) {
        if (data.sale_status === "Hold") {
          $(row).css("background-color", "#f7f7f7");
        }
      },
      drawCallback: function () {
              
        $('#neworderTable_old .amt-due-link').off('click').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          
          try {
            const encodedData = $(this).attr('data-order');
            const row = JSON.parse(decodeURIComponent(encodedData));
            //console.log("Decoded row data:", row); // Debug log
            
            // Call the handler function
            handleAmtDueClick(row);
          } catch (error) {
            console.error("Error parsing row data:", error);
          }
        });
      },
    });

    // Handle other actions
    $("#neworderTable_old")
      .off("click", '[data-action="hold"]')
      .on("click", '[data-action="hold"]', function (e) {
        e.preventDefault();
        setSelectedOrder($(this).data("order"));
        setShowHoldModal(true);
      });

    $("#neworderTable_old")
      .off("click", ".ConvertToNewOrder")
      .on("click", ".ConvertToNewOrder", function (e) {
        e.preventDefault();
        handleNewStatus($(this).data("order"));
      });

    $("#neworderTable_old")
      .off("click", ".printQuotation")
      .on("click", ".printQuotation", function (e) {
        e.preventDefault();
        handleGenerateQuotePDF($(this).data("id"));
      });

    return () => {
      if ($.fn.DataTable.isDataTable($table)) {
        $table.DataTable().ajax.reload();
      }
    };
  };

  const colorRow = (row, field) =>
    row.sale_status === "Hold"
      ? `<span style="color: #f14240;">${row[field]}</span>`
      : `<span>${row[field]}</span>`;

  const dataTableInitialized = useRef(false);

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    if (!dataTableInitialized.current) {
      getSalesOrderList();
      dataTableInitialized.current = true;
    }

    return () => {
      if (
        salesOrderRef.current &&
        $(salesOrderRef.current).length &&
        $.fn.DataTable.isDataTable(salesOrderRef.current)
      ) {
        $(salesOrderRef.current).DataTable().destroy(true);
        dataTableInitialized.current = false;
      }
    };
  }, []);

  const debouncedReloadTable = useRef(
    debounce(() => {
      if (dataTableInitialized.current && $.fn.DataTable.isDataTable(salesOrderRef.current)) {
        $(salesOrderRef.current).DataTable().ajax.reload();
      }
    }, 200)
  ).current;

  useEffect(() => {
    if (dataTableInitialized.current && $.fn.DataTable.isDataTable(salesOrderRef.current)) {
      const table = $(salesOrderRef.current).DataTable();
      tableColumns.forEach((column, index) => {
        const isVisible = columnVisibility[index] !== false;
        table.column(index).visible(isVisible);
      });
    }
  }, [columnVisibility]);

  const searchFormData = () => {
    getSalesOrderList();
  };

  const [checkedItems, setCheckedItems] = useState({});

  const handleSubmit = async () => {
    const checkedValues = $(".dataTableCheckboxNew:checked")
      .map(function () {
        return $(this).val();
      })
      .get();

    console.log("Checked Values:", checkedValues);

    if (checkedValues.length === 0) {
      Swal.fire({
        title: "Failed!",
        text: "Please select an order to accept.",
        icon: "error",
        timer: 1500,
        showConfirmButton: false,
      });
      return;
    }

    const formData = new FormData();
    checkedValues.forEach((value) => formData.append("val[]", value));

    try {
      const response = await fetch(`${config.API_URL}/sales/add_orders_front_sheet`, {
        method: "POST",
        headers: { authorization: `Bearer ${accessToken}` },
        body: formData,
      });

      const data = await response.json();
      console.log("API Response:", data);
      setFlashMessage({ message: "Accept Order successfully", type: "success" });

      debouncedReloadTable();
    } catch (error) {
      console.error("Error Accepting Order:", error);
      setFlashMessage({ message: "Error Accepting Order. Check console for details", type: "error" });
    }
  };

  const handleNewStatus = (id, accessToken) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to transfer this order to new sales?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, proceed",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        let userId = localStorage.getItem("userId");
        const accessToken = localStorage.getItem("accessToken");
        const formData = new FormData();
        formData.append("status", "New");
        formData.append("id", id);
        formData.append("reason_note", "");
        formData.append("user_id", userId);
        formData.append("new-sales", 'No');
        
        axios
          .post(`${config.API_URL}/ws-update-status`, formData, {
            headers: {
              authorization: `Bearer ${accessToken}`,
            },
          })
          .then((response) => {
            if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
              $('#neworderTable_old').DataTable().ajax.reload();
            } else {
              getSalesOrderList();
            }
            Swal.fire("Success", "Order has been transferred!", "success");
          })
          .catch((error) => {
            Swal.fire("Error", "Something went wrong!", "error");
            console.error("Error:", error);
          });
      }
    });
  };

  const updateReject = async (event) => {
    event.preventDefault();

    if (!orderIdRef.current || !reasonRef.current) {
      alert("Required form elements are missing. Please try again.");
      return;
    }

    const orderId = orderIdRef.current.value;
    const reason = reasonRef.current.value;
    const formData = new FormData();
    formData.append("status", "Hold");
    formData.append("reason_note", reason);
    formData.append("id", orderId);
    formData.append("new-sales", 'No');
    
    try {
      const response = await fetch(`${config.API_URL}/ws-update-status`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `HTTP error! Status: ${response.status}. Error: ${errorText}`
        );
      }

      const data = await response.json();
      console.log(data);
      Swal.fire({
        title: "Success!",
        text: "Order Hold successfully.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
      
      if ($.fn.DataTable.isDataTable('#neworderTable_old')) {
        $('#neworderTable_old').DataTable().ajax.reload();
      } else {
        getSalesOrderList();
      }
    } catch (error) {
      console.error("Error holding order:", error);
      alert("Error holding an order. Please check the console for details.");
    }
    setShowHoldModal(false);
  };

  // FIXED: Render Amt Due Modal with proper structure
  const renderAmtDueModal = () => {
    if (!showAmtDueModal) return null;

    return (
      <div 
        className="modal fade show d-block" 
        tabIndex="-1" 
        style={{ 
          display: "block", 
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 1050 
        }}
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">Amount Dues Invoices for {amtDueCustomer}</h6>
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => setShowAmtDueModal(false)} 
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {amtDueLedgerData === null ? (
                <div className="text-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p>Loading ledger data...</p>
                </div>
              ) : amtDueLedgerData.length === 0 ? (
                <div className="text-center">
                  <p>No Dues Invoice for this customer.</p>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-bordered table-striped dataTable">
                    <thead className="table-dark">
                      <tr>
                        <th scope="col" style={{ width: "50px" }}>#</th>
                        <th>Date</th>
                        <th>Order No</th>
                        <th>Invoice Date</th>
                        <th>Amount</th>                       
                      </tr>
                    </thead>
                    <tbody>
                            {amtDueLedgerData.map((item, idx) => {
                              const formatDate = (dateStr) => {
                                if (!dateStr) return "";
                                const date = new Date(dateStr);
                                const day = String(date.getDate()).padStart(2, "0");
                                const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
                                const year = date.getFullYear();
                                return `${day}-${month}-${year}`;
                              };

                              return (
                                <tr key={idx}>
                                  <td >{idx + 1}</td>
                                  <td>{formatDate(item.order_date)}</td>
                                  <td>
                                    <a
                                      href={`${config.BASE_URL}/new_sales/invoice/${item.id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item.reference_no}
                                    </a>
                                  </td>
                                  <td>{formatDate(item.invoice_date)}</td>
                                  <td style={{ textAlign: "right" }}>{item.grand_total}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                           <tfoot>
                          <tr>
                            <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
                              Total
                            </td>
                            <td style={{ textAlign: "right", fontWeight: "bold" }}>
                              {amtDueLedgerData.reduce(
                                (sum, item) => sum + parseFloat(item.grand_total || 0),
                                0
                              ).toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>
                  </table>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button 
                type="button" 
                className="btn btn-secondary btn-sm" 
                onClick={() => setShowAmtDueModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Header />
      {Object.values(columnVisibility).every(visible => !visible) && (
        <FallbackManageColumns
          onOpenModal={() => setShowFallbackModal(true)}
        />
      )}
      
      {/* Reject Modal */}
      {showRejectModal && (
        <div
          className="modal fade show d-block"
          id="rejectOrderMdl"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject Order</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowRejectModal(false)}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className="rejectorder-popup">
                  <form>
                    <h4>Sale Details</h4>
                    <table className="table table-bordered">
                      <tbody>
                        <tr>
                          <td>Order Id</td>
                          <td>{rejectData.reference_no}</td>
                        </tr>
                        <tr>
                          <td>Customer (A/C)</td>
                          <td>{rejectData.customer}</td>
                        </tr>
                        <tr>
                          <td>Order Amount</td>
                          <td>{rejectData.grand_total}</td>
                        </tr>
                        <tr>
                          <td>Previous Dues</td>
                          <td>{rejectData.prev_due}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="form-group">
                      <label className="col-form-label">Reason Note</label>
                      <textarea
                        className="form-control"
                        value={rejectComment}
                        onChange={handleRejCommentChange}
                        placeholder="Leave Comment"
                      />
                    </div>
                    <button
                      type="button"
                      onClick={rejectFormData}
                      className="updatebtn left"
                    >
                      Update
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Hold Modal */}
      {showHoldModal && (
        <div
          className="modal fade show d-block"
          id="reject-order"
          tabIndex="-1"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Hold Order</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowHoldModal(false)}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                {selectedOrder && (
                  <div className="rejectorder-popup">
                    <form id="rejectForm">
                      <div className="form-group">
                        <label>Reason Note</label>
                        <textarea
                          id="reason"
                          name="reason"
                          ref={reasonRef}
                          className="form-control"
                          placeholder="Enter reason for holding the order"
                        ></textarea>
                      </div>
                      <input
                        type="hidden"
                        name="order_id"
                        id="order_id"
                        ref={orderIdRef}
                        value={selectedOrder}
                      />
                      <button
                        type="button"
                        onClick={updateReject}
                        className="updatebtn left updateReject"
                      >
                        Update
                      </button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* FIXED: Amt Due Modal - Now properly rendered */}
      {renderAmtDueModal()}

      <div className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <Link to="/Dashboard">
                <i className="fa fa-home"></i>
              </Link>
              <Link to="/reports/sales_report">Sales</Link>
              <Link to="/reports/sales_report">New sales</Link>
            </div>
          </div>
        </div>
      </div>

      <div className="main-container position-relative">
        <div className="container-fluid">
          <div className="row align-items-center new-sales-custom-filter">
            <div className="date-range-picker col-md-6 col-lg-6 col-sm-6">
              <CommonDatePicker
                value={dates}
                showOneCalendar
                onChange={handleDateRangeChange}
                format="dd/MM/yyyy"
                character=" - "
                className="dashdate mt-1"
                style={{ width: "100%" }}
              />
            </div>

            <div className="col-md-6 col-lg-6 col-sm-3 d-flex">
              <button
                onClick={handleSubmit}
                type="button"
                className="acceptbtn mt-1"
              >
                Accept Order
              </button>
            </div>
          </div>

          <div className="new-sales-table" style={{ position: "relative" }}>
            <div
              className="verical-scrl-wrapper autoheight-table new-sales responsive-height-table"
              id="style-3"
            >
              <table
                className="table toggleColumn table-bordered resizable resizable-columns responsive-height-table"
                ref={salesOrderRef}
                id="neworderTable_old"
              >
                <thead>
                  <tr>
                    <th
                      style={{ width: colWidths[0], minWidth: 50, position: "relative" }}
                    >
                      <label className="checkbox">
                        <input
                          type="checkbox"
                          className="dataTableCheckboxNew"
                          id="selectAllCheckbox"
                          onChange={handleSelectAll}
                        />
                        <span className="default"></span>
                      </label>
                      {colWidths.length > 1 && (
                        <div
                          className="th-resizer"
                          onMouseDown={(e) => startResizing(0, e)}
                        />
                      )}
                    </th>
                    {tableColumns.slice(1).map((column, idx) => (
                      <th
                        key={column.header}
                        style={{
                          width: colWidths[idx + 1],
                          minWidth: 50,
                          position: "relative",
                          display: columnVisibility[idx + 1] !== false ? 'table-cell' : 'none'
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          {column.header}
                          {idx + 1 < colWidths.length && (
                            <>
                              <div
                                className="th-resizer"
                                onMouseDown={(e) => startResizing(idx + 1, e)}
                              />
                              <ManageColumns
                                tableName={tableName}
                                header={column.header}
                                index={idx + 1}
                                columns={tableColumns}
                                columnVisibility={columnVisibility}
                                onColumnVisibilityChange={handleColumnVisibilityChange}
                                excludeColumns={["Checkbox", "Action"]}
                              />
                            </>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody></tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Change Customer Modal */}
      <div
        ref={changeCustmodalRef}
        className="modal fade"
        id="changeCustMdl"
        aria-hidden="true"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Update Customer</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="rejectorder-popup">
                <form>
                  <h4>Sale Details</h4>
                  <table className="table table-bordered resizable">
                    <tbody>
                      <tr>
                        <td>Order Id</td>
                        <td>{changeCustData.reference_no}</td>
                      </tr>
                      <tr>
                        <td>Customer (A/C)</td>
                        <td>{changeCustData.customer}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="col-md-5 cp-lg-5 col-sm-5">
                    <div className="form-group">
                      <label style={{ marginBottom: "5px" }}>
                        <b>Select Customer</b>
                      </label>
                      <Select
                        isClearable
                        onInputChange={handleInputChange}
                        onChange={handleChange}
                        options={customerOptions}
                        placeholder="Search..."
                        value={customerInputValue}
                      />
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={changeCustFormData}
                    data-bs-dismiss="modal"
                    className="updatebtn left"
                  >
                    Update
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <StandaloneManageColumnsModal
        show={showFallbackModal}
        onHide={() => setShowFallbackModal(false)}
        tableName={tableName}
        columns={tableColumns}
        columnVisibility={columnVisibility}
        onColumnVisibilityChange={handleColumnVisibilityChange}
        excludeColumns={["Checkbox", "Action"]}
      />

      <FlashMessage
        message={flashMessage?.message}
        type={flashMessage?.type}
        onClose={handleCloseMessage}
      />
    </div>
  );
};

export default NewRSales;